import store from "@/store";
import {FuneralPlanTab} from "@/shared/domain/enum/funeral-plan-tab.model";
import ContractService from "@/services/ContractService";
import {AxiosResponse} from "axios";
import {RouteRecordRaw} from "vue-router";
import {NavigationGuardNext} from "vue-router";
import FuneralPlanGroupService from "@/services/FuneralPlanGroupService";
import {IFuneralPlanGroup} from "@/shared/domain/funeral-plan-group.model";
import {AWS_ASSETS_URL} from "@/constants";

/**
 * PREVENT products routes
 */

const PreventRouteSettings = {
  checkRouteDependecies: (path: string, next:NavigationGuardNext, index = 0) => {
    if(!store.getters.firstLoad) {
      store.commit("saveStateToCache");
    } else {
      PreventRouteSettings.checkForCacheData();
    }
    if(path[0] == '/') {
      path = path.replace('/', '');
    }
    path = path.split('/')[index];
    switch(path) {
      case 'fornecedor':
      case 'filter':
        if(PreventRouteSettings.checkDependencies(0)) {
          next();
        } else {
          next({path: '/'});
        }
        break
      case 'repay':
        if(PreventRouteSettings.checkDependencies(0)) {
          next();
        } else {
          next({path: '/'});
        }
        break
      case 'location':
        if(PreventRouteSettings.checkDependencies(1)) {
          next();
        } else {
          next({path: '/'});
        }
        break
      case 'payer':
        if(PreventRouteSettings.checkDependencies(2)) {
          next();
        } else {
          next({path: '/'});
        }
        break
      case 'payment-method':
        if(PreventRouteSettings.checkDependencies(2)) {
          next();
        } else {
          next({path: '/'});
        }
        break
      case 'beneficiaries':
        if(PreventRouteSettings.checkDependencies(2)) {
          next();
        } else {
          next({path: '/'});
        }
        break
      case 'full':
        if(PreventRouteSettings.checkDependencies(2)) {
          next();
        } else {
          next({path: '/'});
        }
        break
      case 'pacote':
        if(PreventRouteSettings.checkDependencies(3)) {
          next();
        } else {
          next({path: '/'});
        }
        break
      case 'pagamento':
        if(PreventRouteSettings.checkDependencies(3)) {
          next();
        } else {
          next({path: '/'});
        }
        break
      case 'pagamento-realizado':
        if(PreventRouteSettings.checkDependencies(4)) {
          next();
        } else {
          next({path: '/'});
        }
        break
    }
  },
  checkDependencies: (index: number):boolean => {
    let value = true;
    for(let i = 0; i <= index && value; i++) {
      const d = PreventRouteSettings.ifDependencies[i];
      value = d();
    }
    return value;
  },
  ifDependencies: [
    ():boolean => {
      return store.getters.getSelectedFuneralPlanGroup;
    },
    ():boolean => {
        return store.getters.getSelectedFuneralPlanGroup.bioparque
        || (store.getters.getFuneralPlanFilterOptions && store.getters.getFuneralPlanFilterOptions.length > 0) && store.getters.getFuneralPlanHolder;
    },
    ():boolean => {
      return store.getters.getBeneficiaryDeath
        || store.getters.getSelectedFuneralPlanGroup.bioparque
        || store.getters.getCity
        || store.getters.getStateProvince
        || store.getters.getDeceasedTransportCoverType
    },
    ():boolean => {
      if (store.getters.getFuneralPlanTab === FuneralPlanTab.PREVENT &&
        store.getters.getSelectedFuneralPlanGroup.bioparque) {
        return store.getters.getFuneralPlanSupplier && store.getters.getFuneralPlanHolder;
      }
      return store.getters.getFuneralPlanSupplier; //3
    },
    ():boolean => {
      const finishedPurchase = localStorage.getItem("finishedPurchase");
      return store.getters.getContract || finishedPurchase; //4
    }
  ],
  checkForCacheData: () => {
    if(store.getters.firstLoad) {
      store.commit('updateFirstLoad');
      const cacheDataJson = localStorage.getItem("state");
      if(cacheDataJson) {
        const cacheData = JSON.parse(cacheDataJson);
        if(cacheData["funeralPlanTab"] == store.getters.getFuneralPlanTab) {
          store.commit("updateState", cacheData);
        } else {
          store.commit("resetValues");
        }
      }
    }
  },
  forceToFilterByLegacySupplierCompaniesId: (next:NavigationGuardNext, force = false) => {
    store.commit('changeForceToFilterByLegacySupplierCompaniesId', force ? 104807 : null);
    next();
  }
}

const PreventRoute: RouteRecordRaw = {
  alias: 'prevent',
  path: 'plano',
  name: 'Planos Assistenciais',
  component: () => import("@/components/BasicRouter.vue"),
  beforeEnter: async (to, from, next) => {
    if(store.getters.getFuneralPlanTab == FuneralPlanTab.LOST_SOMEONE) {
      store.commit('resetValues');
    }
    store.commit('changeFuneralPlanTab', FuneralPlanTab.PREVENT);

    const res = await FuneralPlanGroupService.query({
      'lostSomeone.equals': false
    });

    const funeralPlansGroup = res.data || [];
    funeralPlansGroup.forEach((d:IFuneralPlanGroup) => {
      if (!d.bioparque) {
        store.commit('changeSelectedFuneralPlanGroup', d);
      }
      d.imageLink = AWS_ASSETS_URL + (d.image?.name || 'image/noPhoto.png');
    });

    next();
  },
  children: [
    {
      path: 'group',
      component: () => import("@/views/FuneralPlanGroupPage.vue"),
      beforeEnter: (to, from, next) => {
        PreventRouteSettings.checkForCacheData();
        PreventRouteSettings.forceToFilterByLegacySupplierCompaniesId(next);
        next();
      }
    },
    // {
    //   path: 'filter',
    //   beforeEnter: (to, from, next) => {
    //     PreventRouteSettings.checkRouteDependecies(to.path, next, 1);
    //   },
    //   meta: {
    //     solidBackground: true
    //   },
    //   component: () => import("@/views/FuneralPlanFilterPage.vue")
    // },
    // {
    //   path: 'location',
    //   beforeEnter: (to, from, next) => {
    //     PreventRouteSettings.checkRouteDependecies(to.path, next, 1);
    //   },
    //   meta: {
    //     solidBackground: true
    //   },
    //   component: () => import("@/views/prevent/prevent-location-coverage-filter-page/prevent-location-coverage-filter-page.vue")
    // },
    {
      path: 'supplier',
      redirect: {name: 'prevent-fornecedor'},
    },
    {
      name: 'prevent-fornecedor',
      path: 'fornecedor',
      beforeEnter: async (to, from, next) => {
        store.commit('resetValues');
        store.commit('changeFuneralPlanTab', FuneralPlanTab.PREVENT);

        const res = await FuneralPlanGroupService.query({
          'lostSomeone.equals': false
        });

        const funeralPlansGroup = res.data || [];
        funeralPlansGroup.forEach((d:IFuneralPlanGroup) => {
          if (!d.bioparque) {
            store.commit('changeSelectedFuneralPlanGroup', d);
          }
          d.imageLink = AWS_ASSETS_URL + (d.image?.name || 'image/noPhoto.png');
        });
        store.commit('changeInitPurchaseUrl', to.fullPath);
        PreventRouteSettings.checkRouteDependecies(to.path, next, 1);
      },
      meta: {
        spacingTop: true,
        solidBackground: true
      },
      component: () => import("@/views/plans/supplier/FuneralPlanSupplierPage.vue")
    },
    // {
    //   path: 'beneficiaries',
    //   beforeEnter: (to, from, next) => {
    //     PreventRouteSettings.checkRouteDependecies(to.path, next, 1);
    //   },
    //   meta: {
    //     spacingTop: true,
    //   },
    //   component: () => import("@/views/prevent/prevent-plan-beneficiaries-page/PreventPlanBeneficiariesPage.vue")
    // },
    // {
    //   path: 'payer',
    //   beforeEnter: (to, from, next) => {
    //     PreventRouteSettings.checkRouteDependecies(to.path, next, 1);
    //   },
    //   meta: {
    //     spacingTop: true,
    //   },
    //   component: () => import("@/views/prevent/prevent-payer-data-page/PreventPayerDataPage.vue")
    // },
    // {
    //   path: 'payment-method',
    //   beforeEnter: (to, from, next) => {
    //     PreventRouteSettings.checkRouteDependecies(to.path, next, 1);
    //   },
    //   meta: {
    //     spacingTop: true,
    //   },
    //   component: () => import("@/views/prevent/prevent-payment-method-page/PreventPaymentMethodPage.vue")
    // },
    // {
    //   path: 'full',
    //   beforeEnter: (to, from, next) => {
    //     PreventRouteSettings.checkRouteDependecies(to.path, next, 1);
    //   },
    //   meta: {
    //     spacingTop: true,
    //   },
    //   component: () => import("@/views/prevent/PreventPlanContractPage.vue")
    // },
    // {
    //   path: 'repay',
    //   beforeEnter: (to, from, next) => {
    //     if (to.query && to.query.repayToken) {
    //       store.commit('changingRepayToken', to.query.repayToken);
    //       ContractService.findByRepayToken(to.query.repayToken as string).then((res: AxiosResponse) => {
    //         if (res && res.data) {
    //           res.data.funeralPlanSupplier.defaultPrice = res.data.price;
    //           store.commit('changeFuneralPlanSupplier', res.data.funeralPlanSupplier);
    //           store.commit('changePetSupportAdded', res.data.petSupportAdded);
    //           store.commit('changeContract', res.data);
    //         }
    //         next();
    //       }).catch(() => {
    //         next({path: '/'});
    //       });
    //     } else {
    //       next({path: '/'});
    //     }
    //   },
    //   meta: {
    //     spacingTop: true,
    //   },
    //   component: () => import("@/views/prevent/prevent-plan-repay/PreventPlanRepayPage.vue")
    // },
    {
      path: 'contract',
      redirect: {name: 'prevent-pacote'}
    },
    {
      name: 'prevent-pacote',
      path: 'pacote',
      beforeEnter: (to, from, next) => {
        PreventRouteSettings.checkRouteDependecies(to.path, next, 1);
      },
      meta: {
        spacingTop: true,
      },
      component: () => import("@/views/funeral-plan-contract/FuneralPlanContractPage.vue")
    },
    {
      path: 'success',
      redirect: {name: 'prevent-pagamento-realizado'}
    },
    {
      name: 'prevent-pagamento-realizado',
      path: 'pagamento-realizado',
      beforeEnter: (to, from, next) => {
        PreventRouteSettings.checkRouteDependecies(to.path, next, 1);
      },
      meta: {
        spacingTop: true,
      },
      component: () => import("@/views/payment/payment-success/FuneralPlanContractSuccessPage.vue")
    },
    {
      path: 'payment',
      redirect: {name: 'prevent-pagamento'}
    },
    {
      name: 'prevent-pagamento',
      path: 'pagamento',
      beforeEnter: (to, from, next) => {
        PreventRouteSettings.checkRouteDependecies(to.path, next, 1);
      },
      meta: {
        spacingTop: true,
      },
      component: () => import("@/views/payment/PaymentContractPage.vue")
    },
  ]
}
export default PreventRoute;
